const audioCtx: AudioContext = new window.AudioContext();
const sampleRate: number = audioCtx.sampleRate;

export {
    audioCtx, sampleRate
}